import React from "react";

const DietCard = (props) => {
  const { lightTitle, boldContent, svgIcon, filterType, onClickCard, isActive } =
    props || {};

  return (
    <div
      // className="three-content-card-container"
      className={`three-content-card-container ${isActive === filterType ? "active" : ""}`}
      onClick={() => onClickCard(filterType)}
    >
      <div className="card-sec card-top card-flex-start">
        <div className="card-icon">{svgIcon || <></>}</div>
        <div className="card-light-title">
          <p className="light-title">{lightTitle}</p>
        </div>
      </div>
      <div className="card-sec card-below card-bold">
        <p className="bold-content">{boldContent}</p>
      </div>
    </div>
  );
};

export default DietCard;
